// Onboarding wallet deposit helpers (mirrors api/src/services/walletDeposit.js limits).

export const DEPOSIT_MIN = 10;
export const DEPOSIT_MAX = 2000;
export const DEFAULT_RECHARGE = 25;
export const TRIAL_DAYS = 30;

/**
 * Validate a typed custom deposit.
 * @param {string} raw - Raw input value.
 * @returns {{amount: number|null, error: string}} amount is null until the value is valid.
 */
export function parseCustomAmount(raw) {
  const text = String(raw ?? '').trim();
  if (!text) return { amount: null, error: '' };
  const n = Number(text);
  if (!Number.isFinite(n)) return { amount: null, error: 'Enter a valid dollar amount' };
  if (n < DEPOSIT_MIN) return { amount: null, error: `Minimum deposit is $${DEPOSIT_MIN}.00` };
  if (n > DEPOSIT_MAX) return { amount: null, error: `Maximum deposit is $${DEPOSIT_MAX.toLocaleString('en-US')}.00` };
  if (Math.abs(n * 100 - Math.round(n * 100)) > 1e-6) return { amount: null, error: 'Use at most 2 decimal places' };
  return { amount: Math.round(n * 100) / 100, error: '' };
}

/** @param {number} n @returns {string} "25.00" — always two decimals. */
export const money = (n) => Number(n || 0).toFixed(2);

/**
 * When the free trial ends: the agent's own trial end if known, else 30 days from now.
 * @param {{trialEndDate?: string|Date}|null} agent
 * @param {Date} [now]
 * @returns {Date}
 */
export function trialEnd(agent, now = new Date()) {
  const own = agent?.trialEndDate ? new Date(agent.trialEndDate) : null;
  if (own && !Number.isNaN(own.getTime())) return own;
  return new Date(now.getTime() + TRIAL_DAYS * 24 * 60 * 60 * 1000);
}

/** @param {Date} d @returns {string} e.g. "November 29, 2026". */
export const formatTrialDate = (d) => d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
